<template>
  <div class="form-check form-check-custom form-check-solid" :class="this.class">
    <input
        :disabled="disabled"
        :checked="Boolean(modelValue)"
        :value="Boolean(modelValue)"
        :name="name"
        :id="id"
        class="form-check-input"
        type="checkbox"
        @input="this.$emit('update:modelValue', Boolean(!modelValue))"
    />
    <label class="form-check-label" :for="id" v-html="this.placeholder"></label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    placeholder: null,
    modelValue: '',
    disabled: null,
    class: null,
    name: null,
    id:null
  }
}
</script>

<style scoped>

</style>